import {getDimensions, getMeasures} from "@/cube/cubejsApi"
import * as _ from "lodash"
import {Option} from "@/ui/Option"
import {EmailCampaignFunnelDimension} from "@/cube"

function toOption(entry: any): Option {
  return <const>{label: entry.shortTitle, value: entry.name}
}

let dimensionsAsOptionsCache: ReadonlyArray<Option> | undefined

function excluded(value: {name: string; isVisible: boolean}) {
  return (
    !value.isVisible ||
    // Cubes for comparisons aren't selectable
    value.name.includes("Compare.") ||
    // Pre-aggregations not used directly
    value.name.startsWith("Cached") ||
    value.name.includes("RankedSuperScore.") ||
    value.name.includes("AssetOwnedSnapshot.") ||
    // By convention metrics and dimension with names starting with _ are hidden
    value.name.includes("._")
  )
}

function convertToOptions(metadata: Array<any>) {
  return _.chain(metadata)
    .reject(excluded)
    .map(toOption)
    .sortBy(option => option.label.toLocaleLowerCase())
    .value()
}

export async function dimensionsAsOptions(): Promise<ReadonlyArray<Option>> {
  // Workaround for EmailCampaignFunnel until we figure out how to handle it
  const emailCampaignFunnelValues = Object.values(EmailCampaignFunnelDimension)
  const dimensions = (await getDimensions()).filter(
    value => !emailCampaignFunnelValues.includes(value.name)
  )

  if (dimensionsAsOptionsCache == null) {
    dimensionsAsOptionsCache = convertToOptions(dimensions)
  }

  return dimensionsAsOptionsCache
}

let measuresAsOptionsCache: ReadonlyArray<Option> | undefined

export async function measuresAsOptions(): Promise<ReadonlyArray<Option>> {
  const measures = await getMeasures()
  if (measuresAsOptionsCache == null) {
    measuresAsOptionsCache = convertToOptions(measures)
  }

  return measuresAsOptionsCache
}
